import { AccountDto } from '../types/AccountDefault.types';
import API from './ApiBase';

export async function getMyAccount() {
  return await API.get<AccountDto>(`/accounts/me`);
}
